/**
 * 公共的枚举，某个模块的特有的枚举请单独建文件，避免文件太长
 */
import GenerateEnum from '../generateEnum'
import { LZ_SERVICE_TYPE } from './commonServiceType.js'
import { getLabelText } from '../utils'

const lzServiceTypeList = LZ_SERVICE_TYPE.enumArray

import { globalThis } from '../utils.js'

const thirdOrderStatus = new GenerateEnum({
  success: {
    value: 1,
    label: getLabelText({ key: 'remote.common.success', text: '成功' })
  },
  fail: {
    value: 0,
    label: getLabelText({ key: 'remotremote.common.failuress', text: '失败' })
  },
  confirm: {
    value: 2,
    label: getLabelText({ key: 'remote.common.toBeConfirmed', text: '待确认' })
  }
})
// 业务类型，00是vat，01是ipp
const systemTypeEnum = new GenerateEnum({
  VAT: {
    value: '00',
    couponBeforeLabel: getLabelText({ key: 'remote.common.justLook', text: '只看' }),
    label: getLabelText({ key: 'remote.common.europeanTaxPass', text: '欧税通' })
  },
  IPP: {
    value: '01',
    couponBeforeLabel: getLabelText({ key: 'remote.common.justLook', text: '只看' }),
    label: getLabelText({ key: 'remote.common.metton', text: '麦德通' })
  },
  XM: {
    value: '04',
    couponBeforeLabel: getLabelText({ key: 'remote.common.justLook', text: '只看' }),
    label: getLabelText({ key: 'remote.common.smallTradeGoesToSea', text: '小贸出海' })
  }
})

const baseURL = '/base-api'
const channelUrl = 'channel'

function channelBaseUrl() {
  return globalThis().platform === systemTypeEnum.IPP ? 'channel/ipp' : channelUrl
}

const ES_BATTERY_LIST_MAP = new GenerateEnum({
  buttonCell: {
    value: '7901',
    label: getLabelText({ key: 'remote.common.buttonBattery', text: '纽扣电池' }),
    key: '${"key":"1864598028204060672","name":"纽扣电池"}',
    typeList: new GenerateEnum({
      ZI: {
        value: '7001',
        key: '${"key":"1864598325190144000","name":"锌空纽扣电池"}',
        label: getLabelText({ key: 'remote.common.zinc-airButtonCell', text: '锌空纽扣电池' })
      },
      AG2O_BN: {
        value: '7002',
        key: '${"key":"1864598511417241600","name":"氧化银纽扣电池"}',
        label: getLabelText({ key: 'remote.common.silverOxideButtonCell', text: '氧化银纽扣电池' })
      },
      AL_BT: {
        value: '7003',
        key: '${"key":"1864598662080835584","name":"碱性纽扣电池"}',
        label: getLabelText({ key: 'remote.common.alkalineButtonCell', text: '碱性纽扣电池' })
      },
      LI_BT: {
        value: '7004',
        key: '${"key":"1864598768314167296","name":"锂纽扣电池"}',
        label: getLabelText({ key: 'remote.common.lithiumButtonCell', text: '锂纽扣电池' })
      },
      OTHER_BT: {
        value: '7005',
        key: '${"key":"1864598839520866304","name":"其他纽扣电池"}',
        label: getLabelText({ key: 'remote.common.otherButtonCells', text: '其他纽扣电池' })
      }
    })
  },
  OrdinaryBatteries: {
    value: '7902',
    key: '${"key":"1864598978419437568","name":"普通电池"}',
    label: getLabelText({ key: 'remote.common.general-purposeBatteries', text: '普通电池' }),
    typeList: new GenerateEnum({
      AL: {
        value: '7006',
        key: '${"key":"1864600304016633856","name":"碱性普通电池"}',
        label: getLabelText({ key: 'remote.common.alkalineGeneral-purposeBatteries', text: '碱性普通电池' })
      },
      ZI_C: {
        value: '7007',
        key: '${"key":"1864600544195063808","name":"锌碳普通电池"}',
        label: getLabelText({ key: 'remote.common.zinc-carbonGeneral-purposeBatteries', text: '锌碳普通电池' })
      },
      LI: {
        value: '7008',
        key: '${"key":"1864600733173624832","name":"锂普通电池（不可充电）"}',
        label: `${getLabelText({
          key: 'remote.common.lithiumGeneral-purposeBatteries',
          text: '锂普通电池'
        })}（${getLabelText({ key: 'remote.common.non-rechargeable', text: '不可充电' })}）`
      },
      OTHER: {
        value: '7009',
        key: '${"key":"1864600879055712256","name":"其他普通电池"}',
        label: getLabelText({ key: 'remote.common.otherGeneral-purposeBatteries', text: '其他普通电池' })
      }
    })
  },
  storageBattery: {
    value: '7903',
    key: '${"key":"1864601028154830848","name":"蓄电池（非工业用、非汽车用）"}',
    label: `${getLabelText({
      key: 'remote.common.battery2',
      text: '蓄电池'
    })}（${getLabelText({ key: 'remote.common.non-industrialUse', text: '非工业用' })}、${getLabelText({
      key: 'remote.common.non-automotiveUse',
      text: '非汽车用'
    })}）`,
    typeList: new GenerateEnum({
      NI_CA: {
        value: '7010',
        key: '${"key":"1864601186569498624","name":"镍镉蓄电池"}',
        label: getLabelText({ key: 'remote.common.nickel-cadmiumRechargeableBatteries', text: '镍镉蓄电池' })
      },
      NI_H: {
        value: '7011',
        key: '${"key":"1864601324377550848","name":"镍金属氢化物蓄电池"}',
        label: getLabelText({
          key: 'remote.common.nickel-metalHydrideRechargeableBatteries',
          text: '镍金属氢化物蓄电池'
        })
      },
      LI_ELC: {
        value: '7012',
        key: '${"key":"1864601488332894208","name":"锂蓄电池（可充电）"}',
        label: `${getLabelText({
          key: 'remote.common.lithiumRechargeableBatteries',
          text: '锂蓄电池'
        })}（${getLabelText({ key: 'remote.common.rechargeable', text: '可充电' })}）`
      },
      LE: {
        value: '7013',
        key: '${"key":"1864601630997950464","name":"铅酸蓄电池"}',
        label: getLabelText({ key: 'remote.common.lead-acidBattery', text: '铅酸蓄电池' })
      },
      OTHER_REC: {
        value: '7014',
        key: '${"key":"1864601831879946240","name":"其他蓄电池"}',
        label: getLabelText({ key: 'remote.common.otherRechargeableBatteries', text: '其他蓄电池' })
      }
    })
  },
  carBatteries: {
    value: '7904',
    key: '${"key":"1864602089296965632","name":"汽车电池"}',
    label: getLabelText({ key: 'remote.common.automotiveBatteries', text: '汽车电池' }),
    typeList: new GenerateEnum({
      LE_CAR: {
        value: '7015',
        key: '${"key":"1864602815641366528","name":"铅酸汽车电池"}',
        label: getLabelText({ key: 'remote.common.lead-acidAutomotiveBatteries', text: '铅酸汽车电池' })
      },
      LI_CAR: {
        value: '7016',
        key: '${"key":"1864602987490390016","name":"锂离子汽车电池"}',
        label: getLabelText({ key: 'remote.common.lithium-ionAutomotiveBattery', text: '锂离子汽车电池' })
      }
    })
  },
  industrialBatteries: {
    value: '7905',
    key: '${"key":"1864603156713779200","name":"工业类电池"}',
    label: getLabelText({ key: 'remote.common.industrialBatteries', text: '工业类电池' }),
    typeList: new GenerateEnum({
      REC_IND_CA: {
        value: '7017',
        key: '${"key":"1864603282324795392","name":"蓄电池和工业电池（含镉）"}',
        label: `${getLabelText({
          key: 'remote.common.batteriesAndIndustrialBatteries',
          text: '蓄电池和工业电池'
        })}（${getLabelText({ key: 'remote.common.cadmium-containing', text: '含镉' })}）`
      },
      REC_IND_LE: {
        value: '7018',
        key: '${"key":"1864603434703859712","name":"蓄电池和工业电池（含铅）"}',
        label: `${getLabelText({
          key: 'remote.common.batteriesAndIndustrialBatteries',
          text: '蓄电池和工业电池'
        })}（${getLabelText({ key: 'remote.common.lead-containing', text: '含铅' })}）`
      }
    })
  },
  batteryAndIndustrialBattery: {
    value: '7906',
    key: '${"key":"1864603612248748032","name":"蓄电池和工业电池（无铅无镉）"}',
    label: `${getLabelText({
      key: 'remote.common.batteriesAndIndustrialBatteries',
      text: '蓄电池和工业电池'
    })}（${getLabelText({
      key: 'remote.common.lead-freeAndCadmium-free',
      text: '无铅无镉'
    })}）`,
    typeList: new GenerateEnum({
      IND_NI_H: {
        value: '7019',
        key: '${"key":"1864603761582747648","name":"工业镍氢（重量大于等于1公斤）"}',
        label: `${getLabelText({
          key: 'remote.common.industrialNickel-hydrogen',
          text: '工业镍氢'
        })}（${getLabelText({
          key: 'remote.common.weightGreaterThanOrEqualTo1Kilogram',
          text: '重量大于等于1公斤'
        })}）`
      },
      IND_LI: {
        value: '7020',
        key: '${"key":"1864603866863972352","name":"工业锂离子（重量大于等于1公斤）"}',
        label: `${getLabelText({
          key: 'remote.common.industrialLithium-ion',
          text: '工业锂离子'
        })}（${getLabelText({
          key: 'remote.common.weightGreaterThanOrEqualTo1Kilogram',
          text: '重量大于等于1公斤'
        })}）`
      }
    })
  },
  otherIndustrial: {
    value: '7907',
    key: '${"key":"1864603997659148288","name":"其他工业类"}',
    label: getLabelText({ key: 'remote.common.otherIndustrialCategories', text: '其他工业类' }),
    typeList: new GenerateEnum({
      OTHER_IND: {
        value: '7021',
        key: '${"key":"1864604117679157248","name":"其他工业用电池"}',
        label: getLabelText({ key: 'remote.common.otherIndustrialBatteries', text: '其他工业用电池' })
      }
    })
  },
  RechargeableIndustrialBatteries: {
    value: '8913',
    key: '${"key":"1976949810032795648","name":"可充电工业电池"}',
    label: getLabelText({ key: 'remote.common.rechargeableIndustrialBatteries', text: '可充电工业电池' }),
    typeList: new GenerateEnum({
      LI_NMC_BATTERY: {
        value: '8050',
        key: '${"key":"1976949810032795649","name":"锂NMC(镍-锰-钴)工业电池"}',
        label: getLabelText({ key: 'remote.common.liNMCBattery', text: '锂NMC(镍-锰-钴)工业电池' })
      },
      LI_NMC_RESIDENCE_BATTERY: {
        value: '8051',
        key: '${"key":"1976949810032795650","name":"锂NMC(镍-锰-钴)住宅自用电池"}',
        label: getLabelText({
          key: 'remote.common.lithiumNMCResidentialSelfBatteries',
          text: '锂NMC(镍-锰-钴)住宅自用电池'
        })
      },
      LI_NMC_INDUSTRY_BATTERY: {
        value: '8052',
        key: '${"key":"1976949810032795651","name":"锂NMC(镍-锰-钴)工业自用电池"}',
        label: getLabelText({
          key: 'remote.common.lithiumNMCIndustrialSelfuseBatteries',
          text: '锂NMC(镍-锰-钴)工业自用电池'
        })
      },
      LI_NMC_POWER_STATION: {
        value: '8053',
        key: '${"key":"1976949810032795652","name":"NMC锂电池用于可再生能源电站"}',
        label: getLabelText({
          key: 'remote.common.nMCLithiumBatteriesforRenewableEnergyPowerStations',
          text: 'NMC锂电池用于可再生能源电站'
        })
      },
      LI_LFP_INDUSTRY_BATTERY: {
        value: '8054',
        key: '${"key":"1976949810032795653","name":"锂LFP(锂-铁磷酸)工业电池"}',
        label: getLabelText({
          key: 'remote.common.lithiumLFPLithiumIronPhosphateIndustrialBatteries',
          text: '锂LFP(锂-铁磷酸)工业电池'
        })
      },
      LI_LFP_RESIDENCE_BATTERY: {
        value: '8055',
        key: '${"key":"1976949810032795654","name":"锂LFP(锂-铁磷酸)住宅自用电池"}',
        label: getLabelText({
          key: 'remote.common.lithiumLFPResidentialSelfuseBatteries',
          text: '锂LFP(锂-铁磷酸)住宅自用电池'
        })
      },
      LI_LFP_INDUSTRY_SELF_BATTERY: {
        value: '8056',
        key: '${"key":"1976949810032795655","name":"锂LFP(锂-铁磷酸)工业自用电池"}',
        label: getLabelText({
          key: 'remote.common.lithiumLFPIndustrialSelfuseBatteries',
          text: '锂LFP(锂-铁磷酸)工业自用电池'
        })
      },
      LI_LFP_POWER_STATION: {
        value: '8057',
        key: '${"key":"1976949810032795656","name":"LFP锂电池用于可再生能源电站"}',
        label: getLabelText({
          key: 'remote.common.lFPLithiumBatteriesforRenewableEnergyPowerStations',
          text: 'LFP锂电池用于可再生能源电站'
        })
      },
      OTHER_LI_INDUSTRY_BATTERY: {
        value: '8058',
        key: '${"key":"1976949810032795657","name":"其他锂电池技术工业电池"}',
        label: getLabelText({
          key: 'remote.common.otherLithiumBatteryTechnologiesIndustrialBatteries',
          text: '其他锂电池技术工业电池'
        })
      },
      OTHER_LI_RESIDENCE_BATTERY: {
        value: '8059',
        key: '${"key":"1976949810032795658","name":"其他锂电池住宅自用电池"}',
        label: getLabelText({
          key: 'remote.common.otherLithiumBatteryResidentialSelfuse',
          text: '其他锂电池住宅自用电池'
        })
      },
      OTHER_LI_INDUSTRY_SELF_BATTERY: {
        value: '8060',
        key: '${"key":"1976949810032795659","name":"其他锂电池工业自用电池"}',
        label: getLabelText({
          key: 'remote.common.otherLithiumBatteriesIndustrialSelfuse',
          text: '其他锂电池工业自用电池'
        })
      },
      OTHER_LI_POWER_STATION: {
        value: '8061',
        key: '${"key":"1976949810032795660","name":"其他锂电池技术用于可再生能源电站"}',
        label: getLabelText({
          key: 'remote.common.otherLithiumTechnologiesRenewableEnergyPowerStations',
          text: '其他锂电池技术用于可再生能源电站'
        })
      },
      PB_INDUSTRY_BATTERY: {
        value: '8062',
        key: '${"key":"1976949810032795661","name":"铅酸工业电池(Pb)"}',
        label: getLabelText({ key: 'remote.common.leadAcidIndustrialBatteriesPb', text: '铅酸工业电池(Pb)' })
      },
      NICD_INDUSTRY_BATTERY: {
        value: '8063',
        key: '${"key":"1976949810032795662","name":"镍镉工业电池(Ni.Cd)"}',
        label: getLabelText({
          key: 'remote.common.nickelCadmiumIndustrialBatteriesNiCd',
          text: '镍镉工业电池(Ni.Cd)'
        })
      },
      NIMH_INDUSTRY_BATTERY: {
        value: '8064',
        key: '${"key":"1976949810032795663","name":"镍氢工业电池(Ni.Mh)"}',
        label: getLabelText({
          key: 'remote.common.nickelMetalHydrideIndustrialBatteriesNiMH',
          text: '镍氢工业电池(Ni.Mh)'
        })
      },
      OTHER_INDUSTRY_CHARGE_BATTERY: {
        value: '8065',
        key: '${"key":"1976949810032795664","name":"其他工业可充电技术"}',
        label: getLabelText({
          key: 'remote.common.otherIndustrialRechargeableTechnologies',
          text: '其他工业可充电技术'
        })
      }
    })
  },
  NON_RECHARGEABLE_RECHARGEABLE_NON_BUTTON: {
    value: '8909',
    key: '${"key":"1976949810032795665","name":"不可充电电池和蓄电池(非纽扣式)"}',
    label: getLabelText({
      key: 'remote.common.portableNonRechargeableBatteriesAccumulatorsNonbutton',
      text: '不可充电电池和蓄电池(非纽扣式)'
    }),
    typeList: new GenerateEnum({
      ALKALINE_BATTERY_NON_BUTTON_TYPE: {
        value: '8024',
        key: '${"key":"1976949810032795666","name":"碱性电池(非纽扣式)"}',
        label: getLabelText({ key: 'remote.common.alkalineBatteriesNonbutton', text: '碱性电池(非纽扣式)' })
      },
      ZINC_CARBON_BATTERY: {
        value: '8025',
        key: '${"key":"1976949810032795667","name":"锌碳电池"}',
        label: getLabelText({ key: 'remote.common.zincCarbonBatteries', text: '锌碳电池' })
      },
      LI_NON_CHARGE_CN7: {
        value: '8026',
        key: '${"key":"1976949810032795668","name":"锂电池(不可充电)对应中国7号电池"}',
        label: getLabelText({
          key: 'remote.common.lithiumBatteriesNonRechargeableEquivalentChinaNo7Battery',
          text: '锂电池(不可充电)对应中国7号电池'
        })
      },
      LI_NON_CHARGE_CN5: {
        value: '8027',
        key: '${"key":"1976949810032795669","name":"锂电池(不可充电)对应中国5号电池"}',
        label: getLabelText({
          key: 'remote.common.lithiumBatteriesNonRechargeableEquivalentChinaNo5Battery',
          text: '锂电池(不可充电)对应中国5号电池'
        })
      },
      LI_NON_CHARGE_NON_BUTTON: {
        value: '8028',
        key: '${"key":"1976949810032795670","name":"锂电池(不可充电，非纽扣式)"}',
        label: getLabelText({
          key: 'remote.common.lithiumBatteriesNonRechargeableNonButton',
          text: '锂电池(不可充电，非纽扣式)'
        })
      },
      OTHER_NON_CHARGE_NON_BUTTON: {
        value: '8029',
        key: '${"key":"1976949810032795671","name":"其他非纽扣式、不可充电电池"}',
        label: getLabelText({
          key: 'remote.common.otherNonbuttonNonRechargeableBatteries',
          text: '其他非纽扣式、不可充电电池'
        })
      }
    })
  },
  CHARGE_NON_BUTTON: {
    value: '8910',
    key: '${"key":"1976949810032795672","name":"可充电电池(非纽扣式)"}',
    label: getLabelText({
      key: 'remote.common.portableRechargeableBatteriesNonbutton',
      text: '可充电电池(非纽扣式)'
    }),
    typeList: new GenerateEnum({
      NICD_BATTERY: {
        value: '8030',
        key: '${"key":"1976949810032795673","name":"镍镉电池(Ni-Cd)"}',
        label: getLabelText({ key: 'remote.common.nickelCadmiumBatteriesNiCd', text: '镍镉电池(Ni-Cd)' })
      },
      NIMH_BATTERY: {
        value: '8031',
        key: '${"key":"1976949810032795674","name":"镍氢电池(Ni-MH)"}',
        label: getLabelText({ key: 'remote.common.nickelMetalHydrideBatteriesNiMH', text: '镍氢电池(Ni-MH)' })
      },
      LI_CHARGE_NON_BUTTON: {
        value: '8032',
        key: '${"key":"1976949810032795675","name":"可充电锂电池(非纽扣式)"}',
        label: getLabelText({
          key: 'remote.common.rechargeableLithiumBatteriesNonbutton',
          text: '可充电锂电池(非纽扣式)'
        })
      },
      LEAD_ACID_BATTERY: {
        value: '8033',
        key: '${"key":"1976949810032795676","name":"铅酸电池"}',
        label: getLabelText({ key: 'remote.common.leadAcidBatteries', text: '铅酸电池' })
      },
      OTHER_CHARGE_NON_BUTTON: {
        value: '8034',
        key: '${"key":"1976949810032795677","name":"其他非纽扣式可充电电池"}',
        label: getLabelText({
          key: 'remote.common.otherNonButtonRechargeableBatteries',
          text: '其他非纽扣式可充电电池'
        })
      }
    })
  },
  BUTTON_NON_CHARGE: {
    value: '8907',
    key: '${"key":"1976949810032795678","name":"纽扣电池(不可充电)"}',
    label: getLabelText({ key: 'remote.common.portableButtonBatteryNonRechargeable', text: '纽扣电池(不可充电)' }),
    typeList: new GenerateEnum({
      ZINC_AIR_BUTTON_BATTERY: {
        value: '8017',
        key: '${"key":"1976949810032795679","name":"锌空气纽扣电池"}',
        label: getLabelText({ key: 'remote.common.zincAirButtonBatteries', text: '锌空气纽扣电池' })
      },
      SILVER_OXIDE_BUTTON_BATTERY: {
        value: '8018',
        key: '${"key":"1976949810032795680","name":"氧化银纽扣电池"}',
        label: getLabelText({ key: 'remote.common.silverOxideButtonBatteries', text: '氧化银纽扣电池' })
      },
      ALKALINE_BUTTON_MANGANESE_OXIDE: {
        value: '8019',
        key: '${"key":"1976960045668421632","name":"碱性纽扣电池(氧化锰)"}',
        label: getLabelText({
          key: 'remote.common.alkalineButtonBatteriesManganeseOxide',
          text: '碱性纽扣电池(氧化锰)'
        })
      },
      LI_BUTTON_NON_CHARGE_BATTERY: {
        value: '8020',
        key: '${"key":"1976949810032795681","name":"锂纽扣电池(不可充电)"}',
        label: getLabelText({
          key: 'remote.common.lithiumButtonBatteriesNonRechargeable',
          text: '锂纽扣电池(不可充电)'
        })
      },
      OTHER_NON_CHARGE_BUTTON_BATTERY: {
        value: '8021',
        key: '${"key":"1976949810032795682","name":"其他不可充电纽扣电池"}',
        label: getLabelText({
          key: 'remote.common.otherNonRechargeableButtonBatteries',
          text: '其他不可充电纽扣电池'
        })
      }
    })
  },
  BUTTON_CHARGE_BATTERY: {
    value: '8908',
    key: '${"key":"1976949810032795683","name":"纽扣电池(可充电)"}',
    label: getLabelText({ key: 'remote.common.portableButtonBatteriesRechargeable', text: '纽扣电池(可充电)' }),
    typeList: new GenerateEnum({
      LI_BATTERY_CHARGE: {
        value: '8022',
        key: '${"key":"1976949810032795684","name":"锂纽扣电池(可充电)"}',
        label: getLabelText({
          key: 'remote.common.lithiumButtonBatteriesRechargeable',
          text: '锂纽扣电池(可充电)'
        })
      },
      OTHER_BUTTON_BATTERY: {
        value: '8023',
        key: '${"key":"1976949810032795685","name":"其他可充电纽扣电池"}',
        label: getLabelText({ key: 'remote.common.otherRechargeableButtonBatteries', text: '其他可充电纽扣电池' })
      }
    })
  },
  LIGHT_TRAFFIC25: {
    value: '8911',
    key: '${"key":"1976949810032795686","name":"用于轻型交通工具牵引的重量不超过25公斤的电池"}',
    label: getLabelText({
      key: 'remote.common.batteriesforLightTransportTractionWeighing25kg',
      text: '用于轻型交通工具牵引的重量不超过25公斤的电池'
    }),
    typeList: new GenerateEnum({
      LI_NMC_MOTORCYCLE: {
        value: '8035',
        key: '${"key":"1976949810032795687","name":"锂电池NMC(镍-锰-钴)-摩托车"}',
        label: getLabelText({
          key: 'remote.common.lithiumBatteryNMCNickelManganeseCobaltMotorcycles',
          text: '锂电池NMC(镍-锰-钴)-摩托车'
        })
      },
      LI_LFP_MOTORCYCLE: {
        value: '8036',
        key: '${"key":"1976949810032795688","name":"锂电池LFP(磷酸铁锂)-摩托车"}',
        label: getLabelText({
          key: 'remote.common.lithiumBatteryLFPLithiumIronPhosphateMotorcycles',
          text: '锂电池LFP(磷酸铁锂)-摩托车'
        })
      },
      LI_OTHER_MOTORCYCLE: {
        value: '8037',
        key: '${"key":"1976949810032795689","name":"其他锂电池-摩托车"}',
        label: getLabelText({ key: 'remote.common.otherLithiumBatteriesMotorcycles', text: '其他锂电池-摩托车' })
      },
      LEAD_ACID_BATTERY_MOTORCYCLE: {
        value: '8038',
        key: '${"key":"1976949810032795690","name":"铅酸电池-摩托车"}',
        label: getLabelText({ key: 'remote.common.leadAcidBatteriesMotorcycles', text: '铅酸电池-摩托车' })
      },
      NIMH_MOTORCYCLE: {
        value: '8039',
        key: '${"key":"1976949810032795691","name":"镍氢电池(Ni-MH)-摩托车"}',
        label: getLabelText({
          key: 'remote.common.nickelMetalHydrideBatteriesNiMHMotorcycles',
          text: '镍氢电池(Ni-MH)-摩托车'
        })
      },
      OTHER_TECHNOLOGY_MOTORCYCLE: {
        value: '8040',
        key: '${"key":"1976949810032795692","name":"其他技术-摩托车"}',
        label: getLabelText({ key: 'remote.common.otherTechnologiesMotorcycles', text: '其他技术-摩托车' })
      },
      LI_NMC_OTHER_LIGHT: {
        value: '8041',
        key: '${"key":"1976949810032795693","name":"锂电池NMC(镍-锰-钴)-其他轻型交通工具(自行车、电动滑板车等)"}',
        label: getLabelText({
          key: 'remote.common.lithiumNMCBatteriesOtherLightTransportBikesEscootersEtc',
          text: '锂电池NMC(镍-锰-钴)-其他轻型交通工具(自行车、电动滑板车等)'
        })
      },
      LI_LFP_OTHER_LIGHT: {
        value: '8042',
        key: '${"key":"1976949810032795694","name":"锂电池LFP(磷酸铁锂)-其他轻型交通工具(自行车、电动滑板车等)"}',
        label: getLabelText({
          key: 'remote.common.lithiumLFPBatteriesOtherLightTransportBikesScootersetc',
          text: '锂电池LFP(磷酸铁锂)-其他轻型交通工具(自行车、电动滑板车等)'
        })
      },
      OTHER_LI_LIGHT: {
        value: '8043',
        key: '${"key":"1976949810032795695","name":"其他锂电池-其他轻型交通工具(自行车、电动滑板车等)"}',
        label: getLabelText({
          key: 'remote.common.otherLithiumBatteriesOtherLightTransportBikesEScootersEtc',
          text: '其他锂电池-其他轻型交通工具(自行车、电动滑板车等)'
        })
      },
      LEAD_ACID_BATTERY_LIGHT: {
        value: '8044',
        key: '${"key":"1976949810032795696","name":"铅酸电池-其他轻型交通工具(自行车、电动滑板车等)"}',
        label: getLabelText({
          key: 'remote.common.leadAcidBatteriesOtherLightTransportBikesEScootersEtc',
          text: '铅酸电池-其他轻型交通工具(自行车、电动滑板车等)'
        })
      },
      NIMH_BATTERY_LIGHT: {
        value: '8045',
        key: '${"key":"1976949810032795697","name":"镍氢电池(Ni-MH)-其他轻型交通工具(自行车、电动滑板车等)"}',
        label: getLabelText({
          key: 'remote.common.nickelMetalHydrideBatteriesNiMHOtherLightTransportBikescootersetc',
          text: '镍氢电池(Ni-MH)-其他轻型交通工具(自行车、电动滑板车等)'
        })
      },
      OTHER_TECHNOLOGY_OTHER_LIGHT: {
        value: '8046',
        key: '${"key":"1976949810032795698","name":"其他技术-其他轻型交通工具(自行车、电动滑板车等)"}',
        label: getLabelText({
          key: 'remote.common.otherTechnologiesOtherLightTransportBikscootersetc',
          text: '其他技术-其他轻型交通工具(自行车、电动滑板车等)'
        })
      }
    })
  },
  NON_RECHARGEABLE_INDUSTRIAL_BATTERIES: {
    value: '8914',
    key: '${"key":"1976949810032795699","name":"不可充电工业电池"}',
    label: getLabelText({ key: 'remote.common.nonRechargeableIndustrialBatteries', text: '不可充电工业电池' }),
    typeList: new GenerateEnum({
      INDUSTRIAL_ALKALINE_BATTERY: {
        value: '8066',
        key: '${"key":"1976949810032795700","name":"工业碱性电池"}',
        label: getLabelText({ key: 'remote.common.industrialAlkalineBatteries', text: '工业碱性电池' })
      },
      INDUSTRIAL_BATTERY_NON_CHARGE: {
        value: '8067',
        key: '${"key":"1976949810032795701","name":"不可充电锂电池(工业用途)"}',
        label: getLabelText({
          key: 'remote.common.nonRechargeableLithiumBatteriesIndustrialUse',
          text: '不可充电锂电池(工业用途)'
        })
      },
      OTHER_INDUSTRIAL_BATTERY_NON_CHARGE: {
        value: '8068',
        key: '${"key":"1976949810032795702","name":"其他不可充电工业电池技术"}',
        label: getLabelText({
          key: 'remote.common.otherNonRechargeableIndustrialBatteryTechnologies',
          text: '其他不可充电工业电池技术'
        })
      }
    })
  },
  ELECTRIC_HYBRID_VEHICLES25: {
    value: '8915',
    key: '${"key":"1976949810032795703","name":"用于电动车/混合动力车(如摩托车、三轮车及类似车辆)的动力电池，电池重量超过25公斤"}',
    label: getLabelText({
      key: 'remote.common.powerBatteriesforEVsHybridsegMotorcyclesTricyclesWeighingDayu25kg',
      text: '用于电动车/混合动力车(如摩托车、三轮车及类似车辆)的动力电池，电池重量超过25公斤'
    }),
    typeList: new GenerateEnum({
      NMC_ELECTRIC_BATTERY: {
        value: '8069',
        key: '${"key":"1976949810032795704","name":"NMC锂电池(镍-锰-钴)用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆"}',
        label: getLabelText({
          key: 'remote.common.nMCLithiumBatteriesforEVsHybridsPowerMotorcyclesTricyclesEtc',
          text: 'NMC锂电池(镍-锰-钴)用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆'
        })
      },
      LFP_ELECTRIC_BATTERY: {
        value: '8070',
        key: '${"key":"1976949810032795705","name":"LFP锂电池(磷酸铁锂)用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆"}',
        label: getLabelText({
          key: 'remote.common.lFPLithiumBatteriesForEVsHybridsPowerMotorcyclesTricyclesEtc',
          text: 'LFP锂电池(磷酸铁锂)用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆'
        })
      },
      OTHER_ELECTRIC_BATTERY: {
        value: '8071',
        key: '${"key":"1976949810032795706","name":"其他锂电池用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆"}',
        label: getLabelText({
          key: 'remote.common.otherLithiumBatteriesforEVsHybridsPowerMotorcyclesTricyclesEtc',
          text: '其他锂电池用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆'
        })
      },
      NI_MH_ELECTRIC_BATTERY: {
        value: '8072',
        key: '${"key":"1976949810032795707","name":"镍氢电池用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆"}',
        label: getLabelText({
          key: 'remote.common.nickelMetalHydrideBatteriesforEVsHybridsPowerMotorcyclesTricyclesEtc',
          text: '镍氢电池用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆'
        })
      },
      OTHER_TECHNOLOGY_ELECTRIC_BATTERY: {
        value: '8073',
        key: '${"key":"1976949810032795708","name":"其他技术电池用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆"}',
        label: getLabelText({
          key: 'remote.common.otherTechnologyBatteriesforEVsHybridsPowerMotorcyclesTricyclesEtc',
          text: '其他技术电池用于电动车/混合动力车(动力)-摩托车、三轮车及类似车辆'
        })
      }
    })
  },
  AUTOMOTIVE_BATTERIES: {
    value: '8912',
    key: '${"key":"1976949810032795709","name":"汽车电池(启动、点火或照明)"}',
    label: getLabelText({
      key: 'remote.common.automotiveBatteriesStartingIgnitionOrLighting',
      text: '汽车电池(启动、点火或照明)'
    }),
    typeList: new GenerateEnum({
      INDUSTRIAL_ALKALINE_BATTERY: {
        value: '8047',
        key: '${"key":"1976949810032795710","name":"铅酸电池(启动、点火或照明)"}',
        label: getLabelText({
          key: 'remote.common.leadAcidBatteriesStartingIgnitionOrLighting',
          text: '铅酸电池(启动、点火或照明)'
        })
      },
      INDUSTRIAL_BATTERY_NON_CHARGE: {
        value: '8048',
        key: '${"key":"1976949810032795711","name":"锂电池(启动、点火或照明)"}',
        label: getLabelText({
          key: 'remote.common.lithiumBatteriesForStartingIgnitionOrLighting',
          text: '锂电池(启动、点火或照明)'
        })
      },
      OTHER_INDUSTRIAL_BATTERY_NON_CHARGE: {
        value: '8049',
        key: '${"key":"1976949810032795712","name":"其他启动、点火和/或照明电池和电池技术"}',
        label: getLabelText({
          key: 'remote.common.otherStartingIgnitionAndorLightingBatteriesAndTechnologies',
          text: '其他启动、点火和/或照明电池和电池技术'
        })
      }
    })
  }
})
// 平台类型
const platformTypeEnum = new GenerateEnum({
  OST: {
    value: '00',
    label: getLabelText({ key: 'remote.common.europeanTaxPass', text: '欧税通' }),
    registeredAwardLabel: `VAT/EPR+${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  MDT: {
    value: '01',
    label: getLabelText({ key: 'remote.common.metton', text: '麦德通' }),
    registeredAwardLabel: `${getLabelText({
      key: 'remote.common.trademarkRegistration',
      text: '商标注册'
    })}${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  XM: {
    value: '10',
    label: getLabelText({ key: 'remote.common.smallTradeGoesToSea', text: '小贸出海' }),
    registeredAwardLabel: `${getLabelText({
      key: 'remote.common.overseasIndustryAndCommerce',
      text: '境外工商'
    })}${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  LD: {
    value: '08',
    label: getLabelText({ key: 'remote.common.sixDegreesInternational', text: '六度信息' }),
    registeredAwardLabel: `VAT/EPR+${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  TH: {
    value: '13',
    label: getLabelText({ key: 'remote.common.sixDegreesInternational', text: '天合' }),
    registeredAwardLabel: `VAT/EPR+${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  LZ: {
    value: '15',
    label: getLabelText({ key: 'remote.common.greenBoat', text: '绿舟' }),
    registeredAwardLabel: `VAT/EPR+${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  SHUYOU: {
    value: '20',
    label: getLabelText({ key: 'remote.common.shuyou', text: '数游' }),
    registeredAwardLabel: `VAT/EPR+${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  YS: {
    value: '21',
    label: getLabelText({ key: 'remote.common.YS', text: '易思跨境' }),
    registeredAwardLabel: `VAT/EPR+${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  },
  LY: {
    value: '22',
    label: getLabelText({ key: 'remote.common.LY', text: '乐鱼' }),
    registeredAwardLabel: `VAT/EPR+${getLabelText({ key: 'remote.common.bigGiftBag', text: '大礼包' })}`
  }
})

const ES_W3E_LIST_DATA = [
  {
    key: '${"key":"1864608935336423424","name":"具有温度交换的设备"}',
    label: getLabelText({ key: 'remote.common.deviceWithTemperatureExchange', text: '具有温度交换的设备' }),
    value: '5001',
    configId: '5001',
    categoryName: getLabelText({ key: 'remote.common.deviceWithTemperatureExchange', text: '具有温度交换的设备' })
  },
  {
    key: '${"key":"1864609263029006336","name":"屏幕面积大于100平方厘米的显示器、屏幕和设备"}',
    label: getLabelText({ key: 'remote.common.batteriesText1', text: '屏幕面积大于100平方厘米的显示器、屏幕和设备' }),
    value: '5002',
    configId: '5002',
    categoryName: getLabelText({
      key: 'remote.common.batteriesText1',
      text: '屏幕面积大于100平方厘米的显示器、屏幕和设备'
    })
  },
  {
    key: '${"key":"1864609373452447744","name":"灯"}',
    label: getLabelText({ key: 'remote.common.light', text: '灯' }),
    value: '5003',
    configId: '5003',
    categoryName: getLabelText({ key: 'remote.common.light', text: '灯' })
  },
  {
    key: '${"key":"1864609466133983232","name":"大型设备（尺寸大于50厘米）"}',
    label: `${getLabelText({
      key: 'remote.common.largeEquipment',
      text: '大型设备'
    })}（${getLabelText({ key: 'remote.common.sizeIsGreaterThan', text: '尺寸大于' })}50cm）`,
    value: '5004',
    configId: '5004',
    categoryName: `${getLabelText({
      key: 'remote.common.largeEquipment',
      text: '大型设备'
    })}（${getLabelText({ key: 'remote.common.sizeIsGreaterThan', text: '尺寸大于' })}50cm）`
  },
  {
    key: '${"key":"1864609809001558016","name":"小型家电（尺寸小于50厘米）"}',
    label: `${getLabelText({
      key: 'remote.common.smallHouseholdAppliances',
      text: '小型家电'
    })}（${getLabelText({ key: 'remote.common.sizeIsLessThan', text: '尺寸小于' })}50cm）`,
    value: '5005',
    configId: '5005',
    categoryName: `${getLabelText({
      key: 'remote.common.smallHouseholdAppliances',
      text: '小型家电'
    })}（${getLabelText({ key: 'remote.common.sizeIsLessThan', text: '尺寸小于' })}50cm）`
  },
  {
    key: '${"key":"1864609874751467520","name":"小型电信通讯设备"}',
    label: getLabelText({ key: 'remote.common.smallTelecommunicationEquipment', text: '小型电信通讯设备' }),
    value: '5006',
    configId: '5006',
    categoryName: getLabelText({ key: 'remote.common.smallTelecommunicationEquipment', text: '小型电信通讯设备' })
  },
  {
    key: '${"key":"1864609960873111552","name":"大型光伏面板（尺寸大于50厘米）"}',
    label: `${getLabelText({
      key: 'remote.common.largePhotovoltaicPanels',
      text: '大型光伏面板'
    })}（${getLabelText({ key: 'remote.common.sizeIsGreaterThan', text: '尺寸大于' })}50cm）`,
    value: '5007',
    configId: '5007',
    categoryName: `${getLabelText({
      key: 'remote.common.largePhotovoltaicPanels',
      text: '大型光伏面板'
    })}（${getLabelText({ key: 'remote.common.sizeIsGreaterThan', text: '尺寸大于' })}50cm）`
  }
]

const yesNoEnum = new GenerateEnum({
  YES: {
    value: 1,
    str: '1',
    boolean: true,
    label: getLabelText({ key: 'remote.common.yes', text: '是' })
  },
  NO: {
    value: 0,
    str: '0',
    boolean: false,
    label: getLabelText({ key: 'remote.common.no.text', text: '否' })
  }
})

const bankApiCountry = [
  {
    value: 'CN',
    EnName: 'Mainland China',
    label: getLabelText({ key: 'remote.common.mainlandChina', text: '中国內地' })
  },
  { value: 'HK', EnName: 'Hong Kong', label: getLabelText({ key: 'remote.common.hongKongChina', text: '中国香港' }) },
  { value: 'TW', EnName: 'Taiwan', label: getLabelText({ key: 'remote.common.taiwanChina', text: '中国台湾' }) },
  {
    value: 'US',
    EnName: 'United States Of America',
    label: getLabelText({ key: 'remote.common.america', text: '美国' })
  },
  { value: 'GB', EnName: 'United Kingdom', label: getLabelText({ key: 'remote.common.theUk', text: '英国' }) },
  { value: 'AD', EnName: 'Andorra', label: getLabelText({ key: 'remote.common.andorra', text: '安道尔' }) },
  {
    value: 'AE',
    EnName: 'United Arab Emirates',
    label: getLabelText({ key: 'remote.common.unitedArabEmirates', text: '阿拉伯联合酋长国' })
  },
  { value: 'AF', EnName: 'Afghanistan', label: getLabelText({ key: 'remote.common.afghanistan', text: '阿富汗' }) },
  {
    value: 'AG',
    EnName: 'Antigua and Barbuda',
    label: getLabelText({ key: 'remote.common.antiguaAndBarbuda', text: '安提瓜和巴布达' })
  },
  { value: 'AI', EnName: 'Anguilla', label: getLabelText({ key: 'remote.common.anguilla', text: '安圭拉' }) },
  { value: 'AL', EnName: 'Albania', label: getLabelText({ key: 'remote.common.albania', text: '阿尔巴尼亚' }) },
  { value: 'AM', EnName: 'Armenia', label: getLabelText({ key: 'remote.common.armenia', text: '亚美尼亚' }) },
  {
    value: 'AN',
    EnName: 'Netherlands Antilles',
    label: getLabelText({ key: 'remote.common.netherlandsAntilles', text: '荷属安的列斯' })
  },
  { value: 'AO', EnName: 'Angola', label: getLabelText({ key: 'remote.common.angola', text: '安哥拉' }) },
  { value: 'AQ', EnName: 'Antarctica', label: getLabelText({ key: 'remote.common.antarctica', text: '南极洲' }) },
  { value: 'AR', EnName: 'Argentina', label: getLabelText({ key: 'remote.common.argentina', text: '阿根廷' }) },
  {
    value: 'AS',
    EnName: 'American Samoa',
    label: getLabelText({ key: 'remote.common.americanSamoa', text: '美属萨摩亚' })
  },
  { value: 'AT', EnName: 'Austria', label: getLabelText({ key: 'remote.common.austria', text: '奥地利' }) },
  { value: 'AU', EnName: 'Australia', label: getLabelText({ key: 'remote.common.australia', text: '澳大利亚' }) },
  { value: 'AW', EnName: 'Aruba', label: getLabelText({ key: 'remote.common.aruba', text: '阿鲁巴' }) },
  { value: 'AX', EnName: 'Aland Islands', label: getLabelText({ key: 'remote.common.ålandIslands', text: '奥兰群岛' }) },
  { value: 'AZ', EnName: 'Azerbaijan', label: getLabelText({ key: 'remote.common.azerbaijan', text: '阿塞拜疆' }) },
  {
    value: 'BA',
    EnName: 'Bosnia and Herzegovina',
    label: getLabelText({ key: 'remote.common.bosniaAndHerzegovina', text: '波斯尼亚和黑塞哥维那' })
  },
  { value: 'BB', EnName: 'Barbados', label: getLabelText({ key: 'remote.common.barbados', text: '巴巴多斯' }) },
  { value: 'BD', EnName: 'Bangladesh', label: getLabelText({ key: 'remote.common.bangladesh', text: '孟加拉国' }) },
  { value: 'BE', EnName: 'Belgium', label: getLabelText({ key: 'remote.common.belgium', text: '比利时' }) },
  { value: 'BF', EnName: 'Burkina Faso', label: getLabelText({ key: 'remote.common.burkinaFaso', text: '布基纳法索' }) },
  { value: 'BG', EnName: 'Bulgaria', label: getLabelText({ key: 'remote.common.bulgaria', text: '保加利亚' }) },
  { value: 'BH', EnName: 'Bahrain', label: getLabelText({ key: 'remote.common.bahrain', text: '巴林' }) },
  { value: 'BI', EnName: 'Burundi', label: getLabelText({ key: 'remote.common.burundi', text: '布隆迪' }) },
  { value: 'BJ', EnName: 'Benin', label: getLabelText({ key: 'remote.common.benin', text: '贝宁' }) },
  {
    value: 'BL',
    EnName: 'Saint Barthelemy',
    label: getLabelText({ key: 'remote.common.saintBarthélemy', text: '圣巴泰勒米' })
  },
  { value: 'BM', EnName: 'Bermuda', label: getLabelText({ key: 'remote.common.bermuda', text: '百慕大' }) },
  {
    value: 'BN',
    EnName: 'Brunei Darussalam',
    label: getLabelText({ key: 'remote.common.bruneiDarussalam', text: '文莱达鲁萨兰国' })
  },
  {
    value: 'BO',
    EnName: 'Bolivia, Plurinational State of',
    label: getLabelText({ key: 'remote.common.plurinationalStateOfBolivia', text: '多民族玻利维亚国' })
  },
  {
    value: 'BQ',
    EnName: 'Bonaire, Sint Eustatius and Saba',
    label: getLabelText({ key: 'remote.common.bonaire,SintEustatiusAndSaba', text: '博奈尔、圣尤斯特歇斯和萨巴' })
  },
  { value: 'BR', EnName: 'Brazil', label: getLabelText({ key: 'remote.common.brazil', text: '巴西' }) },
  { value: 'BS', EnName: 'Bahamas', label: getLabelText({ key: 'remote.common.theBahamas', text: '巴哈马' }) },
  { value: 'BT', EnName: 'Bhutan', label: getLabelText({ key: 'remote.common.bhutan', text: '不丹' }) },
  { value: 'BV', EnName: 'Bouvet Islands', label: getLabelText({ key: 'remote.common.bouvetIsland', text: '布维岛' }) },
  { value: 'BW', EnName: 'Botswana', label: getLabelText({ key: 'remote.common.botswana', text: '博茨瓦纳' }) },
  { value: 'BY', EnName: 'Belarus', label: getLabelText({ key: 'remote.common.belarus', text: '白俄罗斯' }) },
  { value: 'BZ', EnName: 'Belize', label: getLabelText({ key: 'remote.common.belize', text: '伯利兹' }) },
  { value: 'CA', EnName: 'Canada', label: getLabelText({ key: 'remote.common.canada', text: '加拿大' }) },
  {
    value: 'CC',
    EnName: 'Cocos (Keeling) Islands',
    label: getLabelText({ key: 'remote.common.cocos(keeling)Islands', text: '科科斯（基林）群岛' })
  },
  {
    value: 'CD',
    EnName: 'Congo, Democratic Republic of the',
    label: getLabelText({ key: 'remote.common.democraticRepublicOfTheCongo', text: '刚果民主共和国' })
  },
  {
    value: 'CF',
    EnName: 'Central African Republic',
    label: getLabelText({ key: 'remote.common.centralAfricanRepublic', text: '中非共和国' })
  },
  { value: 'CG', EnName: 'Congo', label: getLabelText({ key: 'remote.common.congo', text: '刚果' }) },
  { value: 'CH', EnName: 'Switzerland', label: getLabelText({ key: 'remote.common.switzerland', text: '瑞士' }) },
  { value: 'CI', EnName: "Cote D'Ivoire", label: getLabelText({ key: 'remote.common.coteDLvoire', text: '科特迪瓦' }) },
  { value: 'CK', EnName: 'Cook Islands', label: getLabelText({ key: 'remote.common.cookIslands', text: '库克群岛' }) },
  { value: 'CL', EnName: 'Chile', label: getLabelText({ key: 'remote.common.chile', text: '智利' }) },
  { value: 'CM', EnName: 'Cameroon', label: getLabelText({ key: 'remote.common.cameroon', text: '喀麦隆' }) },
  { value: 'CO', EnName: 'Colombia', label: getLabelText({ key: 'remote.common.colombia', text: '智利' }) },
  { value: 'CR', EnName: 'Costa Rica', label: getLabelText({ key: 'remote.common.costaRica', text: '哥斯达黎加' }) },
  {
    value: 'CS',
    EnName: 'Serbia and Montenegro',
    label: getLabelText({ key: 'remote.common.serbiaAndMontenegro', text: '塞尔维亚和黑山' })
  },
  {
    value: 'CT',
    EnName: 'Canton and Enderbury Islands',
    label: getLabelText({ key: 'remote.common.cantonAndEnderburyIslands', text: '坎顿和恩德伯里群岛' })
  },
  { value: 'CU', EnName: 'Cuba', label: getLabelText({ key: 'remote.common.cuba', text: '古巴' }) },
  { value: 'CV', EnName: 'Cabo Verde', label: getLabelText({ key: 'remote.common.capeVerde', text: '佛得角' }) },
  { value: 'CW', EnName: 'Curacao', label: getLabelText({ key: 'remote.common.curaçao', text: '库拉索' }) },
  {
    value: 'CX',
    EnName: 'Christmas Island',
    label: getLabelText({ key: 'remote.common.christmasIsland', text: '圣诞岛' })
  },
  { value: 'CY', EnName: 'Cyprus', label: getLabelText({ key: 'remote.common.cyprus', text: '塞浦路斯' }) },
  {
    value: 'CZ',
    EnName: 'Czech Republic',
    label: getLabelText({ key: 'remote.common.czechRepublic', text: '捷克共和国' })
  },
  { value: 'DE', EnName: 'Germany', label: getLabelText({ key: 'remote.common.germany', text: '德国' }) },
  { value: 'DJ', EnName: 'Djibouti', label: getLabelText({ key: 'remote.common.djibouti', text: '吉布提' }) },
  { value: 'DK', EnName: 'Denmark', label: getLabelText({ key: 'remote.common.denmark', text: '丹麦' }) },
  { value: 'DM', EnName: 'Dominica', label: getLabelText({ key: 'remote.common.dominica', text: '多米尼克' }) },
  {
    value: 'DO',
    EnName: 'Dominican Republic',
    label: getLabelText({ key: 'remote.common.dominicanRepublic', text: '多米尼加共和国' })
  },
  { value: 'DZ', EnName: 'Algeria', label: getLabelText({ key: 'remote.common.algeria', text: '阿尔及利亚' }) },
  { value: 'EC', EnName: 'Ecuador', label: getLabelText({ key: 'remote.common.ecuador', text: '厄瓜多尔' }) },
  { value: 'EE', EnName: 'Estonia', label: getLabelText({ key: 'remote.common.ecuador', text: '爱沙尼亚' }) },
  { value: 'EG', EnName: 'Egypt', label: getLabelText({ key: 'remote.common.egypt', text: '埃及' }) },
  {
    value: 'EH',
    EnName: 'Western Sahara',
    label: getLabelText({ key: 'remote.common.westernSahara', text: '西撒哈拉' })
  },
  { value: 'ER', EnName: 'Eritrea', label: getLabelText({ key: 'remote.common.eritrea', text: '厄立特里亚' }) },
  { value: 'ES', EnName: 'Spain', label: getLabelText({ key: 'remote.common.spain', text: '西班牙' }) },
  { value: 'ET', EnName: 'Ethiopia', label: getLabelText({ key: 'remote.common.ethiopia', text: '埃塞俄比亚' }) },
  { value: 'FI', EnName: 'Finland', label: getLabelText({ key: 'remote.common.finland', text: '芬兰' }) },
  { value: 'FJ', EnName: 'Fiji', label: getLabelText({ key: 'remote.common.fiji', text: '斐济' }) },
  {
    value: 'FK',
    EnName: 'Falkland Islands (Malvinas)',
    label: getLabelText({ key: 'remote.common.falklandIslands', text: '福克兰群岛（马尔维纳斯）' })
  },
  {
    value: 'FM',
    EnName: 'Micronesia, Federated States Of',
    label: getLabelText({ key: 'remote.common.federatedStatesOfMicronesia', text: '密克罗尼西亚联邦' })
  },
  { value: 'FO', EnName: 'Faroe Islands', label: getLabelText({ key: 'remote.common.faroeIslands', text: '法罗群岛' }) },
  { value: 'FR', EnName: 'France', label: getLabelText({ key: 'remote.common.france', text: '法国' }) },
  { value: 'GA', EnName: 'Gabon', label: getLabelText({ key: 'remote.common.gabon', text: '加蓬' }) },
  { value: 'GD', EnName: 'Grenada', label: getLabelText({ key: 'remote.common.grenada', text: '格林纳达' }) },
  { value: 'GE', EnName: 'Georgia', label: getLabelText({ key: 'remote.common.georgia', text: '格鲁吉亚' }) },
  {
    value: 'GF',
    EnName: 'French Guiana',
    label: getLabelText({ key: 'remote.common.frenchGuiana', text: '法属圭亚那' })
  },
  { value: 'GG', EnName: 'Guernsey', label: getLabelText({ key: 'remote.common.guernsey', text: '根西岛' }) },
  { value: 'GH', EnName: 'Ghana', label: getLabelText({ key: 'remote.common.ghana', text: '加纳' }) },
  { value: 'GI', EnName: 'Gibraltar', label: getLabelText({ key: 'remote.common.gibraltar', text: '直布罗陀' }) },
  { value: 'GL', EnName: 'Greenland', label: getLabelText({ key: 'remote.common.greenland', text: '格陵兰' }) },
  { value: 'GM', EnName: 'Gambia', label: getLabelText({ key: 'remote.common.theGambia', text: '冈比亚' }) },
  { value: 'GN', EnName: 'Guinea', label: getLabelText({ key: 'remote.common.guinea', text: '几内亚' }) },
  { value: 'GP', EnName: 'Guadeloupe', label: getLabelText({ key: 'remote.common.guadeloupe', text: '瓜德罗普' }) },
  {
    value: 'GQ',
    EnName: 'Equatorial Guinea',
    label: getLabelText({ key: 'remote.common.equatorialGuinea', text: '赤道几内亚' })
  },
  { value: 'GR', EnName: 'Greece', label: getLabelText({ key: 'remote.common.greece', text: '希腊' }) },
  {
    value: 'GS',
    EnName: 'South Georgia and South Sandwich Islands',
    label: getLabelText({
      key: 'remote.common.southGeorgiaAndTheSouthSandwichIslands',
      text: '南乔治亚岛和南桑威奇群岛'
    })
  },
  { value: 'GT', EnName: 'Guatemala', label: getLabelText({ key: 'remote.common.guatemala', text: '危地马拉' }) },
  { value: 'GU', EnName: 'Guam', label: getLabelText({ key: 'remote.common.guam', text: '关岛' }) },
  {
    value: 'GW',
    EnName: 'Guinea Bissau',
    label: getLabelText({ key: 'remote.common.guinea-bissau', text: '几内亚比绍' })
  },
  { value: 'GY', EnName: 'Guyana', label: getLabelText({ key: 'remote.common.guyana', text: '圭亚那' }) },
  {
    value: 'HM',
    EnName: 'Heard and Mcdonald Islands',
    label: getLabelText({ key: 'remote.common.heardIslandAndMcdonaldIslands', text: '赫德岛和麦克唐纳群岛' })
  },
  { value: 'HN', EnName: 'Honduras', label: getLabelText({ key: 'remote.common.honduras', text: '洪都拉斯' }) },
  { value: 'HR', EnName: 'Croatia', label: getLabelText({ key: 'remote.common.croatia', text: '克罗地亚' }) },
  { value: 'HT', EnName: 'Haiti', label: getLabelText({ key: 'remote.common.haiti', text: '海地' }) },
  { value: 'HU', EnName: 'Hungary', label: getLabelText({ key: 'remote.common.hungary', text: '匈牙利' }) },
  { value: 'ID', EnName: 'Indonesia', label: getLabelText({ key: 'remote.common.indonesia', text: '印度尼西亚' }) },
  { value: 'IE', EnName: 'Ireland', label: getLabelText({ key: 'remote.common.ireland', text: '爱尔兰' }) },
  { value: 'IL', EnName: 'Israel', label: getLabelText({ key: 'remote.common.israel', text: '以色列' }) },
  { value: 'IM', EnName: 'Isle Of Man', label: getLabelText({ key: 'remote.common.isleOfMan', text: '马恩岛' }) },
  { value: 'IN', EnName: 'India', label: getLabelText({ key: 'remote.common.india', text: '印度' }) },
  {
    value: 'IO',
    EnName: 'British Indian Ocean Territory',
    label: getLabelText({ key: 'remote.common.britishIndianOceanTerritory', text: '英属印度洋领地' })
  },
  { value: 'IQ', EnName: 'Iraq', label: getLabelText({ key: 'remote.common.iraq', text: '伊拉克' }) },
  {
    value: 'IR',
    EnName: 'Iran, Islamic Republic Of',
    label: getLabelText({ key: 'remote.common.islamicRepublicOfIran', text: '伊朗伊斯兰共和国' })
  },
  { value: 'IS', EnName: 'Iceland', label: getLabelText({ key: 'remote.common.iceland', text: '冰岛' }) },
  { value: 'IT', EnName: 'Italy', label: getLabelText({ key: 'remote.common.italy', text: '意大利' }) },
  { value: 'JE', EnName: 'Jersey', label: getLabelText({ key: 'remote.common.jersey', text: '泽西岛' }) },
  { value: 'JM', EnName: 'Jamaica', label: getLabelText({ key: 'remote.common.jamaica', text: '牙买加' }) },
  { value: 'JO', EnName: 'Jordan', label: getLabelText({ key: 'remote.common.jordan', text: '约旦' }) },
  { value: 'JP', EnName: 'Japan', label: getLabelText({ key: 'remote.common.japan.text', text: '日本' }) },
  { value: 'KE', EnName: 'Kenya', label: getLabelText({ key: 'remote.common.kenya', text: '肯尼亚' }) },
  { value: 'KG', EnName: 'Kyrgyzstan', label: getLabelText({ key: 'remote.common.kyrgyzstan', text: '吉尔吉斯斯坦' }) },
  { value: 'KH', EnName: 'Cambodia', label: getLabelText({ key: 'remote.common.cambodia', text: '柬埔寨' }) },
  { value: 'KI', EnName: 'Kiribati', label: getLabelText({ key: 'remote.common.kiribati', text: '基里巴斯' }) },
  { value: 'KM', EnName: 'Comoros', label: getLabelText({ key: 'remote.common.comoros', text: '科摩罗' }) },
  {
    value: 'KN',
    EnName: 'Saint Kitts and Nevis',
    label: getLabelText({ key: 'remote.common.saintKittsAndNevis', text: '圣基茨和尼维斯' })
  },
  {
    value: 'KP',
    EnName: 'Korea, Dem Peoples Rep Of (North)',
    label: getLabelText({ key: 'remote.common.democraticPeoplesRepublicOfKorea', text: '朝鲜民主主义人民共和国' })
  },
  {
    value: 'KR',
    EnName: 'Korea, Republic Of (South)',
    label: getLabelText({ key: 'remote.common.republicOfKorea', text: '大韩民国' })
  },
  { value: 'KW', EnName: 'Kuwait', label: getLabelText({ key: 'remote.common.kuwait', text: '科威特' }) },
  {
    value: 'KY',
    EnName: 'Cayman Islands',
    label: getLabelText({ key: 'remote.common.caymanIslands', text: '开曼群岛' })
  },
  { value: 'KZ', EnName: 'Kazakhstan', label: getLabelText({ key: 'remote.common.kazakhstan', text: '哈萨克斯坦' }) },
  {
    value: 'LA',
    EnName: 'Lao Peoples Democratic Republic',
    label: getLabelText({ key: 'remote.common.laoPeoplesDemocraticRepublic', text: '老挝人民民主共和国' })
  },
  { value: 'LB', EnName: 'Lebanon', label: getLabelText({ key: 'remote.common.lebanon', text: '黎巴嫩' }) },
  { value: 'LC', EnName: 'Saint Lucia', label: getLabelText({ key: 'remote.common.saintLucia', text: '圣卢西亚' }) },
  {
    value: 'LI',
    EnName: 'Liechtenstein',
    label: getLabelText({ key: 'remote.common.liechtenstein', text: '列支敦士登' })
  },
  { value: 'LK', EnName: 'Sri Lanka', label: getLabelText({ key: 'remote.common.sriLanka', text: '斯里兰卡' }) },
  { value: 'LR', EnName: 'Liberia', label: getLabelText({ key: 'remote.common.liberia', text: '利比里亚' }) },
  { value: 'LS', EnName: 'Lesotho', label: getLabelText({ key: 'remote.common.lesotho', text: '莱索托' }) },
  { value: 'LT', EnName: 'Lithuania', label: getLabelText({ key: 'remote.common.lithuania', text: '立陶宛' }) },
  { value: 'LU', EnName: 'Luxembourg', label: getLabelText({ key: 'remote.common.luxembourg', text: '卢森堡' }) },
  { value: 'LV', EnName: 'Latvia', label: getLabelText({ key: 'remote.common.latvia', text: '拉脱维亚' }) },
  { value: 'LY', EnName: 'Libya', label: getLabelText({ key: 'remote.common.libya', text: '利比亚' }) },
  { value: 'MA', EnName: 'Morocco', label: getLabelText({ key: 'remote.common.morocco', text: '摩洛哥' }) },
  { value: 'MC', EnName: 'Monaco', label: getLabelText({ key: 'remote.common.monaco', text: '摩纳哥' }) },
  {
    value: 'MD',
    EnName: 'Moldova, Republic Of',
    label: getLabelText({ key: 'remote.common.republicOfMoldova', text: '摩尔多瓦共和国' })
  },
  { value: 'ME', EnName: 'Montenegro', label: getLabelText({ key: 'remote.common.montenegro', text: '黑山' }) },
  {
    value: 'MF',
    EnName: 'Saint Martin (French part)',
    label: getLabelText({ key: 'remote.common.saintMartin', text: '法属圣马丁' })
  },
  { value: 'MG', EnName: 'Madagascar', label: getLabelText({ key: 'remote.common.madagascar', text: '马达加斯加' }) },
  {
    value: 'MH',
    EnName: 'Marshall Islands',
    label: getLabelText({ key: 'remote.common.marshallIslands', text: '马绍尔群岛' })
  },
  {
    value: 'MK',
    EnName: 'Macedonia, Former Yugoslav Rep',
    label: getLabelText({ key: 'remote.common.northMacedonia', text: '马其顿,前南斯拉夫共和国' })
  },
  { value: 'ML', EnName: 'Mali', label: getLabelText({ key: 'remote.common.mali', text: '马里' }) },
  { value: 'MM', EnName: 'Myanmar', label: getLabelText({ key: 'remote.common.burma', text: '缅甸' }) },
  { value: 'MN', EnName: 'Mongolia', label: getLabelText({ key: 'remote.common.mongolia', text: '蒙古国' }) },
  { value: 'MO', EnName: 'Macao', label: getLabelText({ key: 'remote.common.macao', text: '澳門' }) },
  {
    value: 'MP',
    EnName: 'Northern Mariana Islands',
    label: getLabelText({ key: 'remote.common.northernMarianaIslands', text: '北马里亚纳群岛' })
  },
  { value: 'MQ', EnName: 'Martinique', label: getLabelText({ key: 'remote.common.martinique', text: '马提尼克' }) },
  { value: 'MR', EnName: 'Mauritania', label: getLabelText({ key: 'remote.common.mauritania', text: '毛里塔尼亚' }) },
  { value: 'MS', EnName: 'Montserrat', label: getLabelText({ key: 'remote.common.montserrat', text: '蒙特塞拉特' }) },
  { value: 'MT', EnName: 'Malta', label: getLabelText({ key: 'remote.common.malta', text: '马耳他' }) },
  { value: 'MU', EnName: 'Mauritius', label: getLabelText({ key: 'remote.common.mauritius', text: '毛里求斯' }) },
  { value: 'MV', EnName: 'Maldives', label: getLabelText({ key: 'remote.common.maldives', text: '马尔代夫' }) },
  { value: 'MW', EnName: 'Malawi', label: getLabelText({ key: 'remote.common.malawi', text: '马拉维' }) },
  { value: 'MX', EnName: 'Mexico', label: getLabelText({ key: 'remote.common.mexico', text: '墨西哥' }) },
  { value: 'MY', EnName: 'Malaysia', label: getLabelText({ key: 'remote.common.malaysia', text: '马来西亚' }) },
  { value: 'MZ', EnName: 'Mozambique', label: getLabelText({ key: 'remote.common.mozambique', text: '莫桑比克' }) },
  { value: 'NA', EnName: 'Namibia', label: getLabelText({ key: 'remote.common.namibia', text: '纳米比亚' }) },
  {
    value: 'NC',
    EnName: 'New Caledonia',
    label: getLabelText({ key: 'remote.common.newCaledonia', text: '新喀里多尼亚' })
  },
  { value: 'NE', EnName: 'Niger', label: getLabelText({ key: 'remote.common.niger', text: '尼日尔' }) },
  {
    value: 'NF',
    EnName: 'Norfolk Island',
    label: getLabelText({ key: 'remote.common.norfolkIsland', text: '诺福克岛' })
  },
  { value: 'NG', EnName: 'Nigeria', label: getLabelText({ key: 'remote.common.nigeria', text: '尼日利亚' }) },
  { value: 'NI', EnName: 'Nicaragua', label: getLabelText({ key: 'remote.common.nicaragua', text: '尼加拉瓜' }) },
  { value: 'NL', EnName: 'Netherlands', label: getLabelText({ key: 'remote.common.netherlands', text: '荷兰' }) },
  { value: 'NO', EnName: 'Norway', label: getLabelText({ key: 'remote.common.norway', text: '挪威' }) },
  { value: 'NP', EnName: 'Nepal', label: getLabelText({ key: 'remote.common.nepal', text: '尼泊尔' }) },
  { value: 'NR', EnName: 'Nauru', label: getLabelText({ key: 'remote.common.nauru', text: '瑙鲁' }) },
  { value: 'NU', EnName: 'Niue', label: getLabelText({ key: 'remote.common.niue', text: '纽埃' }) },
  { value: 'NZ', EnName: 'New Zealand', label: getLabelText({ key: 'remote.common.newZealand', text: '新西兰' }) },
  { value: 'OM', EnName: 'Oman', label: getLabelText({ key: 'remote.common.oman', text: '阿曼' }) },
  { value: 'PA', EnName: 'Panama', label: getLabelText({ key: 'remote.common.panama', text: '巴拿马' }) },
  { value: 'PE', EnName: 'Peru', label: getLabelText({ key: 'remote.common.peru', text: '秘鲁' }) },
  {
    value: 'PF',
    EnName: 'French Polynesia',
    label: getLabelText({ key: 'remote.common.frenchPolynesia', text: '法属波利尼西亚' })
  },
  {
    value: 'PG',
    EnName: 'Papua New Guinea',
    label: getLabelText({ key: 'remote.common.papuaNewGuinea', text: '巴布亚新几内亚' })
  },
  { value: 'PH', EnName: 'Philippines', label: getLabelText({ key: 'remote.common.philippines', text: '菲律宾' }) },
  { value: 'PK', EnName: 'Pakistan', label: getLabelText({ key: 'remote.common.pakistan', text: '巴基斯坦' }) },
  { value: 'PL', EnName: 'Poland', label: getLabelText({ key: 'remote.common.poland', text: '波兰' }) },
  {
    value: 'PM',
    EnName: 'Saint Pierre and Miquelon',
    label: getLabelText({ key: 'remote.common.saintPierreAndMiquelon', text: '圣皮埃尔和密克隆' })
  },
  { value: 'PN', EnName: 'Pitcairn', label: getLabelText({ key: 'remote.common.pitcairnIslands', text: '皮特凯恩' }) },
  { value: 'PR', EnName: 'Puerto Rico', label: getLabelText({ key: 'remote.common.puertoRico', text: '波多黎各' }) },
  {
    value: 'PS',
    EnName: 'Palestine, State of',
    label: getLabelText({ key: 'remote.common.stateOfPalestine', text: '巴勒斯坦国' })
  },
  { value: 'PT', EnName: 'Portugal', label: getLabelText({ key: 'remote.common.portugal', text: '葡萄牙' }) },
  { value: 'PW', EnName: 'Palau', label: getLabelText({ key: 'remote.common.palau', text: '帕劳' }) },
  { value: 'PY', EnName: 'Paraguay', label: getLabelText({ key: 'remote.common.paraguay', text: '巴拉圭' }) },
  { value: 'QA', EnName: 'Qatar', label: getLabelText({ key: 'remote.common.qatar', text: '卡塔尔' }) },
  { value: 'RE', EnName: 'Reunion', label: getLabelText({ key: 'remote.common.réunion', text: '留尼旺' }) },
  { value: 'RO', EnName: 'Romania', label: getLabelText({ key: 'remote.common.romania', text: '罗马尼亚' }) },
  { value: 'RS', EnName: 'Serbia', label: getLabelText({ key: 'remote.common.serbia', text: '塞尔维亚' }) },
  {
    value: 'RU',
    EnName: 'Russian Federation',
    label: getLabelText({ key: 'remote.common.russianFederation', text: '俄罗斯联邦' })
  },
  { value: 'RW', EnName: 'Rwanda', label: getLabelText({ key: 'remote.common.rwanda', text: '卢旺达' }) },
  { value: 'SA', EnName: 'Saudi Arabia', label: getLabelText({ key: 'remote.common.saudiArabia', text: '沙特阿拉伯' }) },
  {
    value: 'SB',
    EnName: 'Solomon Islands',
    label: getLabelText({ key: 'remote.common.solomonIslands', text: '所罗门群岛' })
  },
  { value: 'SC', EnName: 'Seychelles', label: getLabelText({ key: 'remote.common.seychelles', text: '塞舌尔' }) },
  { value: 'SD', EnName: 'Sudan', label: getLabelText({ key: 'remote.common.sudan', text: '苏丹' }) },
  { value: 'SE', EnName: 'Sweden', label: getLabelText({ key: 'remote.common.sweden', text: '瑞典' }) },
  { value: 'SG', EnName: 'Singapore', label: getLabelText({ key: 'remote.common.singapore', text: '新加坡' }) },
  {
    value: 'SH',
    EnName: 'Saint Helena, Ascension and Tristan da Cunha',
    label: getLabelText({
      key: 'remote.common.saintHelena,AscensionAndTristanDaCunha',
      text: '圣赫勒拿-阿森松和特里斯坦-达库尼亚'
    })
  },
  { value: 'SI', EnName: 'Slovenia', label: getLabelText({ key: 'remote.common.slovenia', text: '斯洛文尼亚' }) },
  {
    value: 'SJ',
    EnName: 'Svalbard and Jan Mayen',
    label: getLabelText({ key: 'remote.common.svalbardAndJanMayen', text: '斯瓦尔巴和扬马延' })
  },
  { value: 'SK', EnName: 'Slovakia', label: getLabelText({ key: 'remote.common.slovakia', text: '斯洛伐克' }) },
  { value: 'SL', EnName: 'Sierra Leone', label: getLabelText({ key: 'remote.common.sierraLeone', text: '塞拉利昂' }) },
  { value: 'SM', EnName: 'San Marino', label: getLabelText({ key: 'remote.common.sanMarino', text: '圣马力诺' }) },
  { value: 'SN', EnName: 'Senegal', label: getLabelText({ key: 'remote.common.senegal', text: '塞内加尔' }) },
  { value: 'SO', EnName: 'Somalia', label: getLabelText({ key: 'remote.common.somalia', text: '索马里' }) },
  { value: 'SR', EnName: 'Suriname', label: getLabelText({ key: 'remote.common.suriname', text: '苏里南' }) },
  { value: 'SS', EnName: 'South Sudan', label: getLabelText({ key: 'remote.common.southSudan', text: '南苏丹' }) },
  {
    value: 'ST',
    EnName: 'Sao Tome and Principe',
    label: getLabelText({ key: 'remote.common.saoTomeAndPrincipe', text: '圣多美和普林西比' })
  },
  {
    value: 'SU',
    EnName: 'USSR, Former',
    label: getLabelText({ key: 'remote.common.formerSovietUnion', text: '前苏联' })
  },
  { value: 'SV', EnName: 'El Salvador', label: getLabelText({ key: 'remote.common.elSalvador', text: '萨尔瓦多' }) },
  {
    value: 'SX',
    EnName: 'Sint Maarten (Dutch part)',
    label: getLabelText({ key: 'remote.common.sintMaarten=', text: '荷属圣马丁' })
  },
  {
    value: 'SY',
    EnName: 'Syrian Arab Republic',
    label: getLabelText({ key: 'remote.common.syrianArabRepublic', text: '阿拉伯叙利亚共和国' })
  },
  { value: 'SZ', EnName: 'Eswatini', label: getLabelText({ key: 'remote.common.swaziland', text: '斯威士兰' }) },
  {
    value: 'TC',
    EnName: 'Turks and Caicos Islands',
    label: getLabelText({ key: 'remote.common.turksAndCaicosIslands', text: '特克斯和凯科斯群岛' })
  },
  { value: 'TD', EnName: 'Chad', label: getLabelText({ key: 'remote.common.chad', text: '乍得' }) },
  {
    value: 'TF',
    EnName: 'French Southern Territories',
    label: getLabelText({ key: 'remote.common.frenchSouthernTerritories', text: '法属南部领地' })
  },
  { value: 'TG', EnName: 'Togo', label: getLabelText({ key: 'remote.common.togo', text: '多哥' }) },
  { value: 'TH', EnName: 'Thailand', label: getLabelText({ key: 'remote.common.thailand', text: '泰国' }) },
  { value: 'TJ', EnName: 'Tajikistan', label: getLabelText({ key: 'remote.common.tajikistan', text: '塔吉克斯坦' }) },
  { value: 'TK', EnName: 'Tokelau', label: getLabelText({ key: 'remote.common.tokelau', text: '托克劳' }) },
  { value: 'TL', EnName: 'Timor-Leste', label: getLabelText({ key: 'remote.common.eastTimor', text: '东帝汶' }) },
  { value: 'TM', EnName: 'Turkmenistan', label: getLabelText({ key: 'remote.common.turkmenistan', text: '土库曼斯坦' }) },
  { value: 'TN', EnName: 'Tunisia', label: getLabelText({ key: 'remote.common.tunisia', text: '突尼斯' }) },
  { value: 'TO', EnName: 'Tonga', label: getLabelText({ key: 'remote.common.tonga', text: '汤加' }) },
  { value: 'TP', EnName: 'East Timor', label: getLabelText({ key: 'remote.common.eastTimor', text: '东帝汶' }) },
  { value: 'TR', EnName: 'Turkey', label: getLabelText({ key: 'remote.common.turkey', text: '土耳其' }) },
  {
    value: 'TT',
    EnName: 'Trinidad and Tobago',
    label: getLabelText({ key: 'remote.common.trinidadAndTobago', text: '特立尼达和多巴哥' })
  },
  { value: 'TV', EnName: 'Tuvalu', label: getLabelText({ key: 'remote.common.tuvalu', text: '图瓦卢' }) },
  {
    value: 'TZ',
    EnName: 'Tanzania, United Republic Of',
    label: getLabelText({ key: 'remote.common.unitedRepublicOfTanzania', text: '坦桑尼亚联合共和国' })
  },
  { value: 'UA', EnName: 'Ukraine', label: getLabelText({ key: 'remote.common.ukraine', text: '乌克兰' }) },
  { value: 'UG', EnName: 'Uganda', label: getLabelText({ key: 'remote.common.uganda', text: '乌干达' }) },
  {
    value: 'UM',
    EnName: 'US Minor Outlying Islands',
    label: getLabelText({ key: 'remote.common.unitedStatesMinorOutlyingIslands', text: '美国本土外小岛屿' })
  },
  { value: 'UY', EnName: 'Uruguay', label: getLabelText({ key: 'remote.common.uruguay', text: '乌拉圭' }) },
  { value: 'UZ', EnName: 'Uzbekistan', label: getLabelText({ key: 'remote.common.uzbekistan', text: '乌兹别克斯坦' }) },
  {
    value: 'VA',
    EnName: 'Holy See (Vatican City State)',
    label: getLabelText({ key: 'remote.common.theVatican', text: '梵蒂冈' })
  },
  {
    value: 'VC',
    EnName: 'Saint Vincent and the Grenadines',
    label: getLabelText({ key: 'remote.common.saintVincentAndTheGrenadines', text: '圣文森特和格林纳丁斯' })
  },
  {
    value: 'VE',
    EnName: 'Venezuela, Bolivarian Republic of',
    label: getLabelText({ key: 'remote.common.bolivarianRepublicOfVenezuela', text: '委内瑞拉玻利瓦尔共和国' })
  },
  {
    value: 'VG',
    EnName: 'British Virgin Islands',
    label: getLabelText({ key: 'remote.common.britishVirginIslands', text: '英属维尔京群岛' })
  },
  {
    value: 'VI',
    EnName: 'US Virgin Islands',
    label: getLabelText({ key: 'remote.common.unitedStatesVirginIslands', text: '美属维尔京群岛' })
  },
  { value: 'VN', EnName: 'Viet Nam', label: getLabelText({ key: 'remote.common.vietnam', text: '越南' }) },
  { value: 'VU', EnName: 'Vanuatu', label: getLabelText({ key: 'remote.common.vanuatu', text: '瓦努阿图' }) },
  {
    value: 'WF',
    EnName: 'Wallis and Futuna',
    label: getLabelText({ key: 'remote.common.wallisAndFutuna', text: '瓦利斯和富图纳' })
  },
  { value: 'WS', EnName: 'Samoa', label: getLabelText({ key: 'remote.common.samoa', text: '萨摩亚' }) },
  { value: 'XK', EnName: 'Kosovo', label: getLabelText({ key: 'remote.common.kosovo', text: '科索沃' }) },
  { value: 'YE', EnName: 'Yemen', label: getLabelText({ key: 'remote.common.yemen', text: '也门' }) },
  { value: 'YT', EnName: 'Mayotte', label: getLabelText({ key: 'remote.common.mayotte', text: '马约特' }) },
  { value: 'YU', EnName: 'Yugoslavia', label: getLabelText({ key: 'remote.common.yugoslavia', text: '南斯拉夫' }) },
  { value: 'ZA', EnName: 'South Africa', label: getLabelText({ key: 'remote.common.southAfrica', text: '南非' }) },
  { value: 'ZM', EnName: 'Zambia', label: getLabelText({ key: 'remote.common.zambia', text: '赞比亚' }) },
  { value: 'ZW', EnName: 'Zimbabwe', label: getLabelText({ key: 'remote.common.zimbabwe', text: '津巴布韦' }) }
]
const getColumnsWidth = function (arr) {
  let total = arr.reduce((prev, cur) => {
    let width = cur.width
    if (typeof cur.width == 'string') {
      width = Number(cur.width.replace('px', ''))
    } else {
    }
    return prev + Number(width)
  }, 0)
  return total
}
const filterLzServiceType = function (val) {
  const obj = lzServiceTypeList.find((item) => item.value == val)
  return obj ? obj.serverDetailName || obj.label : ''
}

const filterServiceList = LZ_SERVICE_TYPE.enumArray.filter((item) => {
  return ['9000', '9015', '9016', '9017', '9018', '9019'].includes(item.value)
})
const filterServiceListProduct = LZ_SERVICE_TYPE.enumArray.filter((item) => {
  return ['9000', '9017'].includes(item.value)
})
//报价状态
const lzOfferStatus = [
  { value: '10', label: getLabelText({ key: 'remote.common.pendingQuotation', text: '待报价' }) },
  { value: '20', label: getLabelText({ key: 'remote.common.quoted', text: '已报价' }) },
  { value: '30', label: getLabelText({ key: 'remote.common.toBePaid3', text: '待支付' }) },
  { value: '40', label: getLabelText({ key: 'remote.common.expiredQuote', text: '报价失效' }) }
]

// scence 使用场景 默认 0 所有 1 LZ服务费 2 LZ官费
const offlineInfoScenceEnum = new GenerateEnum({
  ALL: {
    value: 0,
    label: getLabelText({ key: 'remote.common.whole', text: '全部' })
  },
  LZ_SERVICE: {
    value: 1,
    label: 'LZ' + getLabelText({ key: 'remote.common.serviceCharge', text: '服务费' })
  },
  LZ_OFFICIAL: {
    value: 2,
    label: 'LZ' + getLabelText({ key: 'remote.common.officialExpenses', text: '官费' })
  }
})

const batteryTypeMap = {
  3001: '${"key":"1864603240285286400","name":"锂 (Li)"}',
  3002: '${"key":"1864603526030635008","name":"镍锌 (Ni/Zn)"}',
  3003: '${"key":"1864603639817908224","name":"锌空气 (ZnLuft)"}',
  3004: '${"key":"1864603732973400064","name":"碱锰 (AL/Mn)"}',
  3005: '${"key":"1864603839332560896","name":"锌碳 (Zn/C)"}',
  3006: '${"key":"1864603959621005312","name":"氧化银 (AgO)"}',
  3008: '${"key":"1864604092312006656","name":"铅 (Pb)"}',
  3009: '${"key":"1864604200294363136","name":"镍氢 (NiMH)"}',
  3010: '${"key":"1864604292027985920","name":"锂离子 (li-ion)"}',
  3011: '${"key":"1864604442641248256","name":"镍镉 (Ni/Cd)"}',
  3012: '${"key":"1864604648120201216","name":"锂聚合物 (Lithium-Polymer)"}',
  3015: '${"key":"2080535442519019520","name":"含钴锂离子(NCA, NMC)"}',
  3016: '${"key":"2080535673318051840","name":"磷酸铁锂离子(LiFePO₄)"}'
}

const materialList = [
  {
    key: '2001',
    name: '${"key":"1864605618044612608","name":"纸皮"}'
  },
  {
    key: '2002',
    name: '${"key":"1864605527128879104","name":"塑料"}'
  },
  {
    key: '2003',
    name: '${"key":"1864605366159880192","name":"玻璃"}'
  },
  {
    key: '2004',
    name: '${"key":"1864605280851931136","name":"铁"}'
  },
  {
    key: '2005',
    name: '${"key":"1864605168314560512","name":"铝"}'
  },
  {
    key: '2006',
    name: '${"key":"1864605092762562560","name":"饮料纸盒包装"}'
  },
  {
    key: '2007',
    name: '${"key":"1864605015872581632","name":"其他复合包装"}'
  },
  {
    key: '2008',
    name: '${"key":"1864604916706652160","name":"其他材料"}'
  },
  {
    key: '2009',
    name: '${"key":"1864604808493608960","name":"金属"}'
  }
]

const materialList1 = [
  {
    key: '4001',
    name: '${"key":"1864605720318521344","name":"塑料"}'
  },
  {
    key: '4002',
    name: '${"key":"1864605807308386304","name":"纸板&纸张"}'
  },
  {
    key: '4003',
    name: '${"key":"1864605896131162112","name":"玻璃"}'
  },
  {
    key: '4004',
    name: '${"key":"1864606131133820928","name":"金属"}'
  },
  {
    key: '4005',
    name: '${"key":"1864606253263564800","name":"木材"}'
  },
  {
    key: '4006',
    name: '${"key":"1864606337539715072","name":"饮料/食品包装盒"}'
  },
  {
    key: '4007',
    name: '${"key":"1864606415109173248","name":"陶瓷"}'
  },
  {
    key: '4008',
    name: '${"key":"1864606515193655296","name":"橡胶/硅胶"}'
  },
  {
    key: '4009',
    name: '${"key":"1864606581925031936","name":"铝"}'
  },
  {
    key: '4010',
    name: '${"key":"1864606690830135296","name":"其他"}'
  }
]

// 和materialList1不是同一个翻译，如果翻译有调整，请同步调整。这个跟productJs的SPAIN_PACKAGETYPE一致
const materialList2 = [
  {
    value: 4001,
    label: getLabelText({ key: 'remote.common.plastic', text: '塑料' })
  },
  {
    value: 4002,
    label: getLabelText({
      key: ['remote.common.cardboard', '&', 'remote.enumerate.paper'],
      text: '纸板&纸张'
    })
  },
  {
    value: 4003,
    label: getLabelText({ key: 'remote.common.glass', text: '玻璃' })
  },
  {
    value: 4004,
    label: getLabelText({ key: 'remote.common.metal', text: '金属' })
  },
  {
    value: 4005,
    label: getLabelText({ key: 'remote.enumerate.wood', text: '木材' })
  },
  {
    value: 4006,
    label: getLabelText({
      key: ['remote.enumerate.beverage', '/', 'remote.enumerate.foodPackagingBox'],
      text: '饮料/食品包装盒'
    })
  },
  {
    value: 4007,
    label: getLabelText({ key: 'remote.enumerate.ceramics', text: '陶瓷' })
  },
  {
    value: 4008,
    label: getLabelText({
      key: ['remote.common.rubber', '/', 'remote.enumerate.siliconeGel'],
      text: '橡胶/硅胶'
    })
  },
  {
    value: 4009,
    label: getLabelText({ key: 'remote.common.aluminium', text: '铝' })
  },
  {
    value: 4010,
    label: getLabelText({ key: 'remote.common.other', text: '其他' })
  }
]

//主要销售平台枚举
const salesPlatformEnum = [
  {
    label: 'Amaozn',
    value: '0'
  },
  {
    label: 'Ebay',
    value: '2'
  },
  {
    label: 'Shopify',
    value: '32'
  },
  {
    label: 'Zalando',
    value: '33'
  },
  {
    label: 'Cdiscount',
    value: '34'
  },
  {
    label: 'Allegro',
    value: '26'
  },
  {
    label: 'Kaufland.de',
    value: '28'
  },
  {
    label: 'Fnac&Darty',
    value: '7'
  },
  {
    label: 'Temu',
    value: '88'
  },
  {
    label: 'OTTO',
    value: '9'
  },
  {
    label: 'Mano Mano',
    value: '10'
  },
  {
    label: 'Bol.com',
    value: '11'
  },
  {
    label: 'Check24',
    value: '12'
  },
  {
    label: 'Etsy',
    value: '13'
  },
  {
    label: 'For Vegans',
    value: '14'
  },
  {
    label: 'Idealo',
    value: '15'
  },
  {
    label: 'Immaculate Vegan',
    value: '16'
  },
  {
    label: 'Kaufland',
    value: '17'
  },
  {
    label: 'Kauflux',
    value: '18'
  },
  {
    label: 'Lenando',
    value: '19'
  },
  {
    label: 'Onbuy',
    value: '20'
  },
  {
    label: 'Real.de',
    value: '21'
  },
  {
    label: 'Ricardo',
    value: '22'
  },
  {
    label: 'Shop like you give a damn',
    value: '23'
  },
  {
    label: 'Yatego',
    value: '24'
  },
  {
    label: 'Aliababa',
    value: '25'
  },
  {
    label: 'Shopee',
    value: '5'
  },
  {
    label: 'Shein',
    value: '27'
  },
  {
    label: 'MercadoLibre',
    value: '6'
  },
  {
    label: 'Rakuten',
    value: '29'
  },
  {
    label: 'Asos',
    value: '30'
  },
  {
    label: 'AliExpress',
    value: '100'
  },
  {
    label: 'Others',
    value: '1'
  }
]
const couponReceiveTypeEnum = new GenerateEnum({
  ONE: {
    value: 1,
    label: '每次领取一张'
  },
  MULTIPLE: {
    value: 2,
    label: '每次默认领取张数'
  }
})

// 新增枚举：法人关系标识
// const LEGAL_RELATION_TYPE_WORD = window.app.$t('remote.admin.legalRelationTypes').split(',')

const LEGAL_RELATION_TYPE_WORD =
  '法定代表人或监护人;指定代表;共同代表，共同代理人;一般代理人-自然人及法人;提供税务咨询服务的法人;遗产管理人;遗产管理人的代表;遗产继承程序结束后的继承人;遗产继承程序结束后继承人的代表;法人的法定继受人;法人法定继受人的代表'
const LEGAL_RELATION_TYPE_WORD_LIST = getLabelText({
  key: 'remote.admin.legalRelationTypes',
  text: LEGAL_RELATION_TYPE_WORD
}).split(';')
export const LEGAL_RELATION_TYPE = new GenerateEnum({
  // 法定代表人或监护人
  LEGAL_REPRESENTATIVE_OR_GUARDIAN: {
    value: '1',
    label: LEGAL_RELATION_TYPE_WORD_LIST[0]
  },
  DESIGNATED_AGENT: {
    value: '2',
    label: LEGAL_RELATION_TYPE_WORD_LIST[1]
  },
  CO_AGENT: {
    value: '3',
    label: LEGAL_RELATION_TYPE_WORD_LIST[2]
  },
  GENERAL_AGENT: {
    value: '4a',
    label: LEGAL_RELATION_TYPE_WORD_LIST[3]
  },
  TAX_SERVICE_AGENT: {
    value: '4c',
    label: LEGAL_RELATION_TYPE_WORD_LIST[4]
  },
  ESTATE_ADMINISTRATOR: {
    value: '5a',
    label: LEGAL_RELATION_TYPE_WORD_LIST[5]
  },
  ESTATE_ADMINISTRATOR_REP: {
    value: '5b',
    label: LEGAL_RELATION_TYPE_WORD_LIST[6]
  },
  HEIR_BEFORE_LIQUIDATION: {
    value: '6a',
    label: LEGAL_RELATION_TYPE_WORD_LIST[7]
  },
  HEIR_AFTER_LIQUIDATION: {
    value: '6b',
    label: LEGAL_RELATION_TYPE_WORD_LIST[8]
  },
  LEGAL_ENTITY_HEIR: {
    value: '7a',
    label: LEGAL_RELATION_TYPE_WORD_LIST[9]
  },
  LEGAL_ENTITY_HEIR_REP: {
    value: '7b',
    label: LEGAL_RELATION_TYPE_WORD_LIST[10]
  }
})

const CZ_PERSON_TYPE_WORD = '自然人,法人'
const CZ_PERSON_TYPE_WORD_LIST = getLabelText({
  key: 'remote.admin.naturalPerson',
  text: CZ_PERSON_TYPE_WORD
}).split(',')

export const CZ_PERSON_TYPE = new GenerateEnum({
  INDIVIDUAL: {
    value: 'F',
    label: CZ_PERSON_TYPE_WORD_LIST[0]
  },
  LEGAL_ENTITY: {
    value: 'P',
    label: CZ_PERSON_TYPE_WORD_LIST[1]
  }
})

export const WORKSPACE_TODU_TYPE = new GenerateEnum({
  VAT_DECLARE: {
    value: 1,
    label: getLabelText({
      key: 'remote.common.VATBeDeclared',
      text: 'VAT待申报'
    })
  },
  VAT_B2B_DECLARE: {
    value: 2,
    label: getLabelText({
      key: 'remote.common.VATB2BPaddingDeclarat',
      text: 'VAT+B2B待申报'
    })
  },
  B2B_DECLARE: {
    value: 3,
    label: getLabelText({
      key: 'remote.common.B2BPaddingDeclarat',
      text: 'B2B待申报'
    })
  },
  YEAR_DECLARE: {
    value: 4,
    label: getLabelText({
      key: 'remote.common.summarizeTheAnnualReport',
      text: '汇总年报'
    })
  },
  WEEE_DECLARE: {
    value: 5,
    label: getLabelText({
      key: 'remote.common.WEEEBEDeclared',
      text: 'WEEE待申报'
    })
  },
  PACKAGE_DECLARE: {
    value: 6,
    label: getLabelText({
      key: 'remote.common.packagingLawDeclared',
      text: '包装法待申报'
    })
  },
  BATTERY_DECLARE: {
    value: 7,
    label: getLabelText({
      key: 'remote.common.BatteryLawPadding',
      text: '电池法待申报'
    })
  },
  TEXTILE_DECLARE: {
    value: 8,
    label: getLabelText({
      key: 'remote.common.TextileLawPadding',
      text: '纺织法待申报'
    })
  },
  TOY_DECLARE: {
    value: 9,
    label: getLabelText({
      key: 'remote.common.ToyLawPaddingDeclaration',
      text: '玩具法待申报'
    })
  },
  HOME_DECLARE: {
    value: 10,
    label: getLabelText({
      key: 'remote.common.FurnitureLawPadding',
      text: '家具法待申报'
    })
  },
  DIY_DECLARE: {
    value: 11,
    label: getLabelText({
      key: 'remote.common.DIYToolsBeDeclared',
      text: 'DIY和园艺工具待申报'
    })
  },
  PLASTIC_DECLARE: {
    value: 44,
    label: getLabelText({
      key: 'remote.common.plasticTaxBedeclared',
      text: '塑料税待申报'
    })
  },
  SPORTS_DECLARE: {
    value: 45,
    label: getLabelText({
      key: 'remote.common.sportsAndRecreationalSports',
      text: '体育和休闲运动'
    })
  }
})

export const WORK_STATUS_TYPE = new GenerateEnum({
  ME_PENDING: {
    value: -1,
    label: getLabelText({
      key: 'remote.common.illTakeCareOfIt',
      text: '待我处理'
    })
  },
  ME_CHECK_IN: {
    value: -2,
    label: getLabelText({
      key: 'remote.common.waitForMeToConfirm',
      text: '待我确认'
    })
  }
})

export const UPLOAD_PRODUCT_TYPE = new GenerateEnum({
  RPCDEBatteryLaw: {
    value: -1,
    label: '德国电池法',
    import: 'importRPCDEBatteryLaw'
  },
  RPCESBatteryLaw: {
    value: -2,
    label: '西班牙电池法',
    import: 'importRPCESBatteryLaw'
  },
  RPCITBatteryLaw: {
    value: -3,
    label: '意大利电池法',
    import: 'importRPCITBatteryLaw'
  },
  RPCSEBatteryLaw: {
    value: -4,
    label: '瑞典电池法',
    import: 'importRPCSEBatteryLaw'
  },
  RPCPLBatteryLaw: {
    value: -5,
    label: '波兰电池法',
    import: 'importRPCPLBatteryLaw'
  },
  RPCESPacking: {
    value: -6,
    label: '西班牙包装法',
    import: 'importRPCESPacking'
  },
  RPCESWeee: {
    value: -7,
    label: '西班牙WEEE',
    import: 'importRPCESWeee'
  },
  RPCITWeee: {
    value: -8,
    label: '意大利WEEE',
    import: 'importRPCITWeee'
  },
  exportProductData: {
    value: -9,
    label: '导入商品信息',
    import: 'importProductMessage'
  },
  RPCNLBatteryLaw: {
    value: -10,
    label: '荷兰电池法',
    import: 'importRPCNLBatteryLaw'
  },
  RPCNLWeee: {
    value: -11,
    label: '荷兰WEEE',
    import: 'importRPCNLWeee'
  },
  RPCIEBatteryLaw: {
    value: -12,
    label: '爱尔兰电池法',
    import: 'importRPCIEBatteryLaw'
  },
  RPCIEWeee: {
    value: -13,
    label: '爱尔兰WEEE',
    import:'importRPCIEWeee'
  },
  RPCBEBatteryLaw: {
    value: -14,
    label: '比利时电池法',
    import:'importRPCBEBatteryLaw'
  },
  RPCBEWeee: {
    value: -15,
    label: '比利时WEEE',
    import:'importRPCBEWeee'
  },
  RPCBEPacking: {
    value: -6,
    label: '比利时包装法',
    import: 'importRPCBEPacking'
  },
  importModifyTranslation: {
    value: -999,
    label: '批量导入翻译',
    import:'importModifyTranslation'
  },
  importUniversalOrder: {
    value: -1000,
    label: '批量导入万能订单',
    import:'importUniversalOrder'
  },
  testProjectConfig: {
    value: -1001,
    label: '测试项目配置',
    import: 'importTestProjectConfig'
  }
})
const wwwPriceCategory = new GenerateEnum({
  crossBorderCompliance: {
    value: '0',
    label: '跨境合规',
    sort: 0
  },
  trademarkAndPatent: {
    value: '1',
    label: '商标专利',
    sort: 1
  },
  overseasIndustrialAndCommercial: {
    value: '2',
    label: '境外工商财税',
    sort: 2
  },
  carbonCompliance: {
    value: '3',
    label: '碳合规',
    sort: 3
  },
})
export {
  thirdOrderStatus,
  baseURL,
  channelBaseUrl,
  channelUrl,
  systemTypeEnum,
  platformTypeEnum,
  yesNoEnum,
  ES_W3E_LIST_DATA,
  ES_BATTERY_LIST_MAP,
  bankApiCountry,
  lzServiceTypeList,
  filterServiceList,
  filterServiceListProduct,
  getColumnsWidth,
  filterLzServiceType,
  lzOfferStatus,
  offlineInfoScenceEnum,
  batteryTypeMap,
  materialList,
  materialList1,
  materialList2,
  salesPlatformEnum,
  couponReceiveTypeEnum
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/common.js